import React from 'react'
import Card from '@mui/material/Card'
import CardMedia from '@mui/material/CardMedia'
import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'
import ContentOverviewCard, {
  ContentOverviewProps,
} from './ContentOverviewCard'
import EpubViewer from '../Viewer/EpubViewer'
import { FileType } from '../Elements/FileTypeResource'
import ShowFullScreenButton from '../Buttons/ShowFullScreenButton'
import { styled } from '@mui/system'
import { useShowOnDesktop } from '../../hooks/useShowOnDesktop'

const DividerWithMargin = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
}))

interface ContentDetailsProps extends ContentOverviewProps {
  filetype: FileType | null
  viewOnly: boolean
  embedUrl: string | undefined
  showFileByType?: string
}

const ContentDetailsCard: React.FunctionComponent<ContentDetailsProps> = ({
  filetype,
  embedUrl,
  ...rest
}) => {
  const isDesktop = useShowOnDesktop()

  const dontShowIFrame = filetype === FileType.EBook

  const cardMedia = dontShowIFrame ? (
    <Box border={1} borderColor="primary.main">
      <EpubViewer title={rest.title ?? ''} url={embedUrl ?? ''} />
    </Box>
  ) : (
    <Box display="flex" flex="1" height={!isDesktop ? 250 : 600}>
      <CardMedia
        component="iframe"
        src={embedUrl}
        allowFullScreen={true}
        title={rest.title}
      />
    </Box>
  )

  return (
    <Card>
      <Box p={{ xs: 2, sm: 4 }}>
        <ContentOverviewCard
          {...rest}
          mobileMedia={!isDesktop ? cardMedia : undefined}
        />
        <ShowFullScreenButton assetKey={rest.assetKey} />
        {isDesktop && (
          <>
            <DividerWithMargin />
            {cardMedia}
          </>
        )}
      </Box>
    </Card>
  )
}

export default ContentDetailsCard
